// extracted by mini-css-extract-plugin
export default {"arc3-language_selector":"_7OmeieDGERpdxmgUWnKLZQ==","language_selector__content":"OAk-m+L0mU8IkAtYq97VRg=="};